// src/components/directory/DirectoryList.js (DOĞRU NİHAİ ÇÖZÜM)

import ListingCard from './ListingCard.js';
import { Link } from 'react-router-dom';

const DirectoryList = ({ listings, loading, allCategories, userData }) => {

    if (loading) {
        return (
            <div className="text-center py-5">
                <div className="spinner-border text-primary" style={{ width: '3rem', height: '3rem' }} role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }
    
    if (listings.length === 0 && allCategories.length === 1 && allCategories[0] !== "All") {
        return (
           <div className="col-12 text-center bg-light rounded p-5 mt-4">
               <i className="bi bi-journal-x fs-1 text-muted"></i>
               <h4 className="mt-3 fw-light">No Results Found</h4>
               <p className="text-muted">Try adjusting your search or filter criteria.</p>
           </div>
       );
    }

    const isUserSubscribed = userData?.role === 'subscribedUser' || userData?.role === 'admin';
    const freeCategories = ['Authors', 'Illustrators', 'Editors'];

    return (
        <div>
            {allCategories.map((category, index) => {
                const professionalsInCategory = listings.filter(l => l.category === category);
                const isPremium = !freeCategories.includes(category);

                // Eğer kategori premium ise ve kullanıcının aboneliği yoksa,
                // Profesyonel listesi yerine kilitli içerik mesajını göster.
                if (isPremium && !isUserSubscribed) {
                    return (
                        <div key={category} className={index > 0 ? 'mt-5' : ''}>
                             <div className="d-flex align-items-center border-bottom pb-2 mb-4">
                                <h2 className="fw-light mb-0">{category}</h2>
                                <span className="badge bg-primary ms-3">
                                    <i className="bi bi-gem me-1"></i> Premium
                                </span>
                            </div>
                            <div className="text-center p-4 bg-light rounded border">
                                <i className="bi bi-lock-fill fs-1 text-primary mb-3"></i>
                                <h4 className="mt-3 fw-bold">Exclusive Content</h4>
                                <p className="text-muted mb-3">
                                    To access this category, please subscribe.
                                </p>
                                <Link to="/signup" className="btn btn-sm btn-primary">
                                    Become a Member
                                </Link>
                            </div>
                        </div>
                    );
                }

                // Kullanıcının yetkisi varsa veya kategori ücretsizse normal akış devam eder.
                return (
                    <div key={category} className={index > 0 ? 'mt-5' : ''}>
                        <div className="d-flex align-items-center border-bottom pb-2 mb-4">
                            <h2 className="fw-light mb-0">{category}</h2>
                            {isPremium && (
                                <span className="badge bg-primary ms-3">
                                    <i className="bi bi-gem me-1"></i> Premium
                                </span>
                            )}
                        </div>
                        
                        {professionalsInCategory.length > 0 ? (
                            <div className="row row-cols-1 row-cols-lg-2 g-4">
                                {professionalsInCategory.map((listing) => (
                                    <div key={listing.id} className="col">
                                        <ListingCard listing={listing} />
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div className="text-center text-muted p-4 bg-light rounded">
                                <p className="mb-0">There are currently no professionals listed in this category.</p>
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export default DirectoryList;